export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_CONFIRM_SUCCESS = 'RESET_PASSWORD_CONFIRM_SUCCESS';
export const RESET_PASSWORD_CONFIRM_FAIL = 'RESET_PASSWORD_CONFIRM_FAIL';
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const LOADING_WATCHLIST_SUCCESS = 'LOADING_WATCHLIST_SUCCESS';
export const LOADING_WATCHLIST_FAIL = 'LOADING_WATCHLIST_FAIL';
export const LOADING_PUBLIC_KEY_SUCCESS = 'LOADING_PUBLIC_KEY_SUCCESS';
export const LOADING_PUBLIC_KEY_FAIL = 'LOADING_PUBLIC_KEY_FAIL';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const SET_CHART_INTERVAL = 'SET_CHART_INTERVAL';
export const SET_CHART_THEME = 'SET_CHART_THEME';
